module.exports = __webpack_public_path__ + "img/dingdanchaxun.85628891.png";